import styled from 'styled-components';

export const SheetBody = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 24px;
`;

export const FormStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const FieldStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const MonthHint = styled.p`
    margin: 0;
    font-size: 0.875rem;
    color: var(--color-muted-foreground, #6b7280);
`;

export const ErrorText = styled.p`
    margin: 0;
    font-size: 0.875rem;
    color: var(--color-destructive, #dc2626);
`;

export const ActionsRow = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
`;
